import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BruteForce} from "../BruteForce";
import {BruteForceHelper} from "../utils/BruteForceHelper";
import {gsap} from "gsap";


export class BruteForceTransitionShutterView extends PIXI.Container implements StageLayer {

    private _transitionShutter: PIXI.spine.Spine;

    constructor() {
        super();
        this.load();
        this.name = "transitionShutterDoors";
    }

    private load(): void {
        this._transitionShutter = new PIXI.spine.Spine(BruteForce.assetLoader.getSpineAsset("Transition_Shutter"));
        this._transitionShutter.position.set(360, 360);
        this._transitionShutter.visible = false;
        this._transitionShutter.name = "transitionShutter";
        this.addChild(this._transitionShutter);
        this.doorVisibility(false);
    }


    public playDoorClose(): gsap.core.Timeline {
        const closeTL: gsap.core.Timeline = gsap.timeline();
        closeTL.add(BruteForceHelper.playSpineWithTimeline(this._transitionShutter, 0, "intro"));
        closeTL.add(BruteForce.gameContainer.screenShake(0.3, 100, false), "<0.2");
        return closeTL;
    }

    public playDoorOpen(): gsap.core.Timeline {
        const openDoorTl: gsap.core.Timeline = gsap.timeline();
        openDoorTl.add(BruteForceHelper.playSpineWithTimeline(this._transitionShutter, 0, "outro"));
        return openDoorTl;
    }

    public doorVisibility(value: boolean): void {
        this._transitionShutter.visible = value;

        if (!value) {
            BruteForceHelper.resetSpineItem(this._transitionShutter);
            BruteForceHelper.playSpineWithTimeline(this._transitionShutter, 0, "normal");
        }
    }

    public doorAnimationLoop(): void {
        this._transitionShutter.autoUpdate = true;
        this._transitionShutter.state.setAnimation(0, "loop", true);
    }
}